<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.number')">
              <j-input placeholder="请输入编号" v-model="queryParam.code" ></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="名称">
              <j-input :placeholder="$t('label.pleaseEnterTheName')" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.validOrNot')">
                <j-dict-select-tag  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')" v-model="queryParam.validFlag" dictCode="sfyx"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
     <!-- <a-button type="primary" icon="download" @click="handleExportXls('efs_md_material_plan')">{{$t('button.export')}}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-if="record.approvalStatus!='30'" @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider v-if="record.approvalStatus!='30'" type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.reviewApproved')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                  <a-popconfirm :title="$t('tip.rejected')" @confirm="() => handleFailure(record.id)">
                 <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.approvalStatus!='30'">
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-material-plan-modal ref="modalForm" @ok="modalFormOk"/>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdMaterialPlanModal from './modules/EfsMdMaterialPlanModal'
  import '@/assets/less/TableExpand.less'
  import JInput from '@/components/jeecg/JInput'
  import { putAction } from '@api/manage'

  export default {
    name: "EfsMdMaterialPlanList",
    mixins:[JeecgListMixin],
    components: {
      EfsMdMaterialPlanModal,
        JInput
    },
    data () {
      return {
        description: 'efs_md_material_plan管理页面',
        // 表头
        columns: [
          {
            title:'编号',
            align:"center",
            dataIndex: 'code'
          },
          {
            title:'名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            slotName: 'tableHeader.batchNo',
            scopedSlots: { title: 'tableHeader.batchNo'},
            align:"center",
            dataIndex: 'batchCode_dictText'
          },
          {
            slotName: 'tableHeader.farms',
            align:"center",
            dataIndex: 'farmCode_dictText',
            scopedSlots: { title: 'tableHeader.farms'}
          },
          {
            slotName: 'tableHeader.grower',
            scopedSlots: { title: 'tableHeader.grower'},
            align:"center",
            dataIndex: 'farmerCode_dictText'
          },
          {
            slotName: 'tableHeader.contracts',
            scopedSlots: { title: 'tableHeader.contracts'},
            align:"center",
            dataIndex: 'conCode_dictText'
          },
          {
            slotName: 'tableHeader.applicant',
            align:"center",
            dataIndex: 'refApplicantId_dictText',
            scopedSlots: { title: 'tableHeader.applicant'}
          },
          {
            slotName: 'tableHeader.documentDate',
            align:"center",
            dataIndex: 'docDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            },
            scopedSlots: { title: 'tableHeader.documentDate'}
          },
          {
            slotName: 'tableHeader.reviewStatus',
            scopedSlots: { title: 'tableHeader.reviewStatus'},
            align:"center",
            dataIndex: 'approvalStatus_dictText'
          },
          {
            slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
            align:"center",
            dataIndex: 'validFlag_dictText'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
          }
        ],
        url: {
          list: "/materialPickingPlan/efsMdMaterialPlan/list",
          delete: "/materialPickingPlan/efsMdMaterialPlan/delete",
          deleteBatch: "/materialPickingPlan/efsMdMaterialPlan/deleteBatch",
          exportXlsUrl: "/materialPickingPlan/efsMdMaterialPlan/exportXls",
          importExcelUrl: "/materialPickingPlan/efsMdMaterialPlan/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
        handleFailure(id){
            putAction('/materialPickingPlan/efsMdMaterialPlan/updateApprovalStatus', {"id": id, "approvalStatus": "40"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        handlePass(id){
            putAction('/materialPickingPlan/efsMdMaterialPlan/updateApprovalStatus', {"id": id, "approvalStatus": "30"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>